import * as RadixLabel from '@radix-ui/react-label';
import { cn } from '@/shared/lib/cn';
import type { ComponentProps } from 'react';

export function Label({ className, ...props }: ComponentProps<typeof RadixLabel.Root>) {
  return <RadixLabel.Root className={cn('text-fg-muted text-sm font-medium', className)} {...props} />;
}
